<template>
  <div>
    <el-dialog
      :title="titleName"
      @close="closeDialog"
      :visible.sync="dialogVisable"
      :modal-append-to-body="false"
      width="850px"
      height="504px"
      :style="
        myType == 2 || myType == 5 ? 'margin-top:0vh;' : 'margin-top:4vh;'
      "
      class="add-label-dialog"
      :close-on-click-modal="false"
    >
      <div>
        <div class="row">
          <span class="required">*</span>
          <span class="label">{{ myType == 5 ? "消息名称" : "SOP名称" }}</span>
          <div>
            <slot name="value">
              <template>
                <el-input
                  type="text"
                  :placeholder="
                    myType == 5 ? '输入群发消息名称' : '输入SOP名称'
                  "
                  v-model="sopName"
                  maxlength="30"
                  size="small"
                  show-word-limit
                  style="width:280px;"
                >
                </el-input>
              </template>
            </slot>
          </div>
        </div>
        <div class="row">
          <span class="required">*</span>
          <span class="label">选择员工</span>
          <div class="staff-select-wrap">
            <slot name="value">
              <template>
                <el-input
                  type="text"
                  readonly
                  @click.native="selectStaff()"
                  class="my-select"
                  placeholder="添加成员"
                  suffix-icon="el-icon-arrow-down"
                  v-model="selectNum"
                  size="small"
                  show-word-limit
                  style="width:150px;"
                >
                </el-input>
                <div
                  class="after-select"
                  v-show="myType == 2 && selectMemberNames.length != 0"
                >
                  <div class="tip" @click="showOptions">
                    {{ selectOptionShow ? "折叠筛选条件" : "展开筛选条件"
                    }}<i
                      class="btn-icon el-icon-arrow-down"
                      :class="selectOptionShow ? 'btn-icon2' : ''"
                    ></i>
                  </div>
                </div>
              </template>
            </slot>
          </div>
        </div>
        <div class="select-wrap" v-if="selectMemberNames.length != 0">
          <el-tag
            v-for="(item, index) in selectMemberNames"
            :key="index"
            size="small"
            closable
            @close="delSelectedHandle(item)"
          >
            {{ item.name }}
          </el-tag>
        </div>
        <div class="row" v-if="myType == 5">
          <span class="required" style="color: white;">*</span>
          <span class="label">服务客户</span>
          <div>
            <div class="before-select" v-show="selectMemberNames.length == 0">
              选择员工后，自动生成所对应的客户
            </div>
            <div class="after-select" v-show="selectMemberNames.length != 0">
              <div>预计触达{{ selecCusNum }}位客户</div>
              <div class="tip" @click="showOptions">
                {{ selectOptionShow ? "折叠筛选条件" : "展开筛选条件"
                }}<i
                  class="btn-icon el-icon-arrow-down"
                  :class="selectOptionShow ? 'btn-icon2' : ''"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row" v-show="myType == 2 && selectMemberNames.length != 0">
          <span class="required" style="color: white;">*</span>
          <div>
            <div class="after-select" v-show="selectMemberNames.length != 0">
              <div class="tip" @click="showOptions">展开筛选条件<i class="btn-icon el-icon-arrow-down" :class="selectOptionShow?'btn-icon2':''"></i></div>
            </div>
          </div>
        </div> -->
        <el-collapse-transition v-if="myType == 5 || myType == 2">
          <div v-show="selectMemberNames.length != 0 && selectOptionShow">
            <div class="option-container">
              <SelectContain
                ref="selectContain"
                @selectOptions="selectOptions"
              />
            </div>
          </div>
        </el-collapse-transition>
        <div class="row">
          <span class="required">*</span>
          <span class="label">{{ myType == 5 ? "发送内容" : "任务详情" }}</span>
        </div>
        <div class="task-detail">
          <slot name="taskDetail">
            <template v-if="myType == 1">
              <div class="detial-item">
                通过好友
                <el-input
                  class="number-input"
                  type="number"
                  v-model="hours"
                  size="small"
                  :min="0"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width:80px;"
                >
                </el-input>
                小时
                <el-input
                  class="number-input"
                  type="number"
                  v-model="minute"
                  size="small"
                  :min="0"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  style="width:80px;"
                >
                </el-input>
                分钟 后发送
              </div>
            </template>
            <template v-if="myType == 2">
              <div class="detial-item">
                <span>
                  发送时间：客户生日前
                  <el-input
                    v-model="params2.daysAgo"
                    size="small"
                    style="width: 100px; margin: 0 5px;"
                    min="0"
                    type="number"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                  />天</span
                >
                <el-time-picker
                  v-model="params2.sendTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  size="small"
                  :clearable="false"
                  :picker-options="{ selectableRange: DisApplyTimeHours }"
                  style="width:100px;margin:0 12px"
                  placeholder="选择08:35之前"
                >
                </el-time-picker>
                发送
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="将于客户公历生日当天发送祝福"
                  placement="top-start"
                >
                  <i class="el-icon-question icon-style"></i>
                </el-tooltip>
              </div>
            </template>
            <template v-if="myType == 3">
              <div class="detial-item">
                <span class="label">起止时间</span>
                <div>
                  <el-date-picker
                    v-model="searchSelectTime"
                    size="small"
                    :editable="false"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                    :default-time="defaultTime"
                    range-separator="~"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    @change="selectTime"
                    clearable
                    :picker-options="pickerOptions"
                    style="width: 240px; margin-right: 10px"
                  >
                  </el-date-picker>
                </div>
              </div>
            </template>
          </slot>
          <MyUpload
            ref="myUpload"
            :myType="myType"
            @receiveParam="receiveParam"
          />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small " @click="closeDialog" style="margin-right:20px"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="small"
          :disabled="!confirDisable"
          @click="confirmWeicome()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <StaffTree
      ref="myStaffTree"
      :dialogVisibleTree="dialogVisibleTree"
      @closeTree="closeTree"
      :currentSelectMember="selectMember"
      @clickSubmitTree="clickSubmitTree"
      title="选择员工"
    ></StaffTree>
  </div>
</template>
<script>
import StaffTree from "@/components/staffTree/staffTree.vue";
import MyUpload from "@/views/mass/SOP/components/myUpload.vue";
import SelectContain from "@/views/mass/SOP/components/selectContain.vue";
import {
  createFriMomentSop,
  addFriends,
  getScreenCus,
  newBirthday,
  createMsgSend,
} from "@/api/sop/sop.js";
export default {
  // 新建sop任务弹框
  name: "commonSOPDetail",
  components: {
    StaffTree,
    MyUpload,
    SelectContain,
  },
  props: {
    titleName: {
      type: String,
      default: "新增好友SOP",
    },
    myVisiable: {
      type: Boolean,
      default: false,
    },
    // 类型 1为新增好友sop，2为新增生日提醒sop，3为新增朋友圈sop，4为活码，5为群发
    myType: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      sopName: "",
      userList: [],
      selectOptionShow: false,
      // 新增好友参数
      params1: {
        sopName: "",
        userList: [], // 员工列表
        afterAdd: 0,
        content: "",
        resourceVos: [],
        linkVo: {
          linkType: "", // 类型   空为网页链接    goods为商品    coupon为券
          title: "",
          httpUrl: "",
          content: "",
          pictureUrl: "",
          pictureName: "",
          price: "", // 商品/券价格
          couEnableprice: "", //券满可用金额
        },
      },
      hours: 0, // 新增好友sop所需参数
      minute: 5, // 新增好友sop所需参数
      DisApplyTimeHours: "08:35:00 - 23:59:00", // 可选时间范围
      // 新增生日提醒sop参数
      params2: {
        sopName: "",
        userList: [], // 员工列表
        sendTime: "10:00",
        content: "",
        resourceVos: [],
        daysAgo: 0,
        linkVo: {
          linkType: "", // 类型   空为网页链接    goods为商品    coupon为券
          title: "",
          httpUrl: "",
          content: "",
          pictureUrl: "",
          pictureName: "",
          price: "", // 商品/券价格
          couEnableprice: "", //券满可用金额
        },
        condition: {},
      },
      // 朋友圈参数
      params3: {
        sopName: "",
        userList: [], // 员工列表
        startTime: "", // 开始时间，时间到分
        endTime: "",
        content: "",
        resourceVos: [],
        linkVo: {
          linkType: "", // 类型   空为网页链接    goods为商品    coupon为券
          title: "",
          httpUrl: "",
          content: "",
          pictureUrl: "",
          pictureName: "",
          price: "", // 商品/券价格
          couEnableprice: "", //券满可用金额
        },
      },
      // 群发参数
      params5: {
        msgName: "",
        userList: [], // 员工列表
        content: "",
        resourceVos: [],
        linkVo: {
          linkType: "", // 类型   空为网页链接    goods为商品    coupon为券
          title: "",
          httpUrl: "",
          content: "",
          pictureUrl: "",
          pictureName: "",
          price: "", // 商品/券价格
          couEnableprice: "", //券满可用金额
        },
        hmcQwHisCusList: [],
      },
      dialogVisibleTree: false, // 选择成员树
      searchSelectTime: [], // 存放选择时间的数据
      pickerOptions: {
        disabledDate(time) {
          // new Date().setHours(0, 0, 0, 0)
          // return time.getTime() < new Date().setHours(0, 0, 0, 0);
          return time.getTime() < Date.now() - 8.64e7;
          // return time.getTime() < Date.now()-1 * 24 * 3600 * 1000
        },
        selectableRange: "12:00:00 - 23:59:59",
      }, // 时间选择器的筛选条件
      selectMember: [], // 选中的原始成员节点数据
      selectMemberNames: [], // 选中的成员名字
      selectNum: "", // 选中的人数
      selecCusNum: 0, // 选中的客户数
      dialogVisable: false,
      myUploadFlag: false,
      getCusParams: {
        userVoList: [
          //员工列表
          {
            userId: "woHiy3CAAAHXLtpULkXXa58_wmU5N1PQ",
            userName: "黄国锐",
          },
        ],
        mark: 2, //标识  1：生日提醒  2：消息群发
        ctmTagId: [], //标签id
        ctmType: [], //客户装填
        birthday: [], //生日
        sex: [], //性别
        area: [],
        isBlacklist: [], //黑名单
        andOr: "and", //并或 and：并  or：或
      },
    };
  },
  created() {},
  watch: {
    myVisiable(val) {
      this.dialogVisable = val;
      if (val) {
        this.myUploadFlag = false;
        this.initFunc();
      }
    },
  },
  computed: {
    defaultTime() {
      return [this.$moment(new Date()).format("HH:mm:ss"), "23:59:59"];
    },
    confirDisable() {
      let flag = false;
      let strFlag = false;
      console.log("sss", this.myUploadFlag);
      if (this.sopName && this.userList.length != 0 && this.myUploadFlag) {
        strFlag = true;
      }
      if (this.myType == 3) {
        if (this.params3.startTime && strFlag) {
          flag = true;
        }
      } else if (this.myType == 1) {
        if (strFlag) {
          flag = true;
        }
      } else {
        flag = strFlag;
      }
      console.log("confirDisable", flag);
      return flag;
    },
  },
  methods: {
    showOptions() {
      this.selectOptionShow = !this.selectOptionShow;
    },
    closeDialog() {
      this.$emit("closeDialog", false);
    },
    // 初始化函数
    initFunc() {
      // 初始化参数
      this.searchSelectTime = [];
      this.selectMember = []; // 选中的原始成员节点数据
      this.selectMemberNames = []; // 选中的成员名字
      this.selectNum = ""; // 选中的人数
      this.sopName = "";
      this.userList = [];
      this.$nextTick(() => {
        this.$refs.myUpload.initParams();
      });
      if (this.myType == 3) {
        this.params3 = {
          sopName: "",
          userList: [], // 员工列表
          startTime: "", // 开始时间，时间到分
          endTime: "",
          content: "",
          resourceVos: [],
          linkVo: {
            linkType: "", // 类型   空为网页链接    goods为商品    coupon为券
            title: "",
            httpUrl: "",
            content: "",
            pictureUrl: "",
            pictureName: "",
            price: "", // 商品/券价格
            couEnableprice: "", //券满可用金额
          },
        };
      } else if (this.myType == 2 || this.myType == 5) {
        // 生日提醒 群发
        this.params2 = {
          sopName: "",
          userList: [], // 员工列表
          sendTime: "10:00",
          content: "",
          resourceVos: [],
          daysAgo: 0,
          linkVo: {
            linkType: "", // 类型   空为网页链接    goods为商品    coupon为券
            title: "",
            httpUrl: "",
            content: "",
            pictureUrl: "",
            pictureName: "",
            price: "", // 商品/券价格
            couEnableprice: "", //券满可用金额
          },
          condition: {},
        };
        this.params5 = {
          msgName: "",
          userList: [], // 员工列表
          content: "",
          resourceVos: [],
          linkVo: {
            linkType: "", // 类型   空为网页链接    goods为商品    coupon为券
            title: "",
            httpUrl: "",
            content: "",
            pictureUrl: "",
            pictureName: "",
            price: "", // 商品/券价格
            couEnableprice: "", //券满可用金额
          },
          hmcQwHisCusList: [],
        };
        this.getCusParams = {
          userVoList: [], //员工列表
          mark: this.myType == 2 ? 1 : 2, //标识  1：生日提醒  2：消息群发
          ctmTagId: [], //标签id
          ctmType: [], //客户状态
          birthday: [], //生日
          sex: [], //性别
          area: [],
          isBlacklist: [], //黑名单 0 为否 1为是
          andOr: "and", //并或 and：并  or：或
        };
        this.selectOptionShow = false;
        this.selecCusNum = 0;
        this.$nextTick(() => {
          this.$refs.selectContain.initData();
        });
      } else if (this.myType == 1) {
        // 新增好友
        this.params1 = {
          sopName: "",
          userList: [], // 员工列表
          afterAdd: 0,
          content: "",
          resourceVos: [],
          linkVo: {
            linkType: "", // 类型   空为网页链接    goods为商品    coupon为券
            title: "",
            httpUrl: "",
            content: "",
            pictureUrl: "",
            pictureName: "",
            price: "", // 商品/券价格
            couEnableprice: "", //券满可用金额
          },
        };
        this.hours = 0;
        this.minute = 5;
      } else {
      }
    },
    // 新建确定按钮
    confirmWeicome() {
      // console.log('新建确定按钮')
      // console.log(this.params1)
      // return;
      if (this.myType == 5) {
        if (this.selecCusNum == 0) {
          this.$message({
            message: "无满足发送条件的客户",
            type: "info",
            offset: 30,
            duration: 1000,
            customClass: "info-message",
          });
          return;
        } else if (this.selecCusNum > 10000) {
          this.$message({
            message: "单次群发选择客户数量不可超过1万，请按员工分批创建群发",
            type: "info",
            offset: 30,
            duration: 1000,
            customClass: "info-message",
          });
          return;
        }
      }
      if (
        this["params" + this.myType].resourceVos.length != 0 &&
        !(
          JSON.stringify(this["params" + this.myType].linkVo) == "{}" ||
          this["params" + this.myType].linkVo == null
        )
      ) {
        this.$message({
          message: "不允许同时上传图片、视频、链接",
          type: "info",
          offset: 30,
          duration: 1000,
          customClass: "info-message",
        });
        return;
      }
      if (this.myType != 5) {
        this["params" + this.myType].sopName = this.sopName;
      } else {
        this["params" + this.myType].msgName = this.sopName;
      }
      this["params" + this.myType].userList = this.userList;
      this["create" + this.myType]();
    },
    // 新建好友sop接口
    create1() {
      this.params1.afterAdd = parseInt(this.hours * 60) + parseInt(this.minute);
      addFriends(this.params1, localStorage.getItem("Authorization")).then(
        (res) => {
          if (res.error.code == 200) {
            this.$message.success("新建成功!");
            this.closeDialog();
            this.$emit("reGet", "createNew");
          }
        }
      );
    },
    // 新建生日提醒sop接口
    create2() {
      newBirthday(this.params2, localStorage.getItem("Authorization")).then(
        (res) => {
          if (res.error.code == 200) {
            this.$message.success("新建成功!");
            this.closeDialog();
            this.$emit("reGet", "createNew");
          }
        }
      );
    },
    // 新建朋友圈sop接口
    create3() {
      createFriMomentSop(
        this.params3,
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res.error.code == 200) {
          this.$message.success("新建成功!");
          this.closeDialog();
          this.$emit("reGet", "createNew");
        }
      });
    },
    // 新建群发
    create5() {
      // console.log("🚀 ~ file: commonSOPDetail.vue:549 ~ create5 ~ this.getCusParams:", this.getCusParams)
      // console.log("🚀 ~ file: commonSOPDetail.vue:551 ~ create5 ~ this.params5:", this.params5)
      // console.log("🚀 ~ file: commonSOPDetail.vue:551 ~ create5 ~ {...this.params5, ...this.getCusParams, area:this.getCusParams.area[0] }:", {...this.params5, ...this.getCusParams, area:this.getCusParams.area[0] })
      // return;
      createMsgSend(
        {
          ...this.params5,
          ...this.getCusParams,
          area:
            this.getCusParams.area.length > 0 ? this.getCusParams.area[0] : [],
        },
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res.error.code == 200) {
          this.$message.success("新建成功!");
          this.closeDialog();
          this.$emit("reGet", "createNew");
        }
      });
    },
    // 获取客户数
    getScreenCus() {
      getScreenCus(
        {
          ...this.getCusParams,
          area:
            this.getCusParams.area.length > 0 ? this.getCusParams.area[0] : [],
        },
        localStorage.getItem("Authorization")
      ).then((res) => {
        if (res.error.code == 200) {
          this.selecCusNum = res.data.total;
          this.params5.hmcQwHisCusList = res.data.qwHisCusList;
        }
      });
    },
    selectStaff() {
      this.dialogVisibleTree = true;
    },
    selectTime(val) {
      console.log("time", val);
      if (val != null) {
        // if()
        this.params3.endTime = val[1];
        this.params3.startTime = val[0];
      } else {
        this.params3.startTime = "";
        this.params3.endTime = "";
      }
    },
    // 接受上传组件返回的参数
    receiveParam(obj) {
      console.log("obj", obj);
      this.myUploadFlag = obj.flag;
      this["params" + this.myType].content = obj.content;
      this["params" + this.myType].resourceVos = obj.resourceVos;
      this["params" + this.myType].linkVo = obj.linkVo ?? obj.product;
    },
    // 选项框子组件回调函数
    selectOptions(options) {
      console.log("sss13356", options);
      if (this.myType == 5) {
        this.getCusParams.ctmTagId = options.ctmTagId;
        this.getCusParams.ctmType = options.ctmType;
        this.getCusParams.birthday = options.birthday;
        this.getCusParams.sex = options.sex;
        this.getCusParams.area = options.area;
        this.getCusParams.isBlacklist = options.isBlacklist;
        this.getCusParams.andOr = options.andOr;
        this.getScreenCus();
      } else {
        this.params2.condition = {
          mark: this.myType == 2 ? 1 : 2, //标识  1：生日提醒  2：消息群发
          ctmTagId: options.ctmTagId, //标签id
          ctmType: options.ctmType, //客户状态
          birthday: options.birthday, //生日
          sex: options.sex, //性别
          area: options.area,
          isBlacklist: options.isBlacklist, //黑名单
          andOr: options.andOr, //并或 and：并  or：或
        };
      }
    },
    // 删除成员/部门
    delSelectedHandle(item) {
      this.$refs.myStaffTree.clickCurrrntFn(item, true);
    },
    closeTree(val) {
      this.dialogVisibleTree = false;
    },
    // 选定成员
    clickSubmitTree(val) {
      console.log("val", val);
      // val {
      //   currentMember,
      //   currentIdName,
      //   sendArray
      // }
      this.selectMember = JSON.parse(JSON.stringify(val.currentMember)); // 所有节点的集合
      this.selectMemberNames = JSON.parse(JSON.stringify(val.currentIdName)); // 显示名字的集合
      let arr = JSON.parse(JSON.stringify(val.sendArray)); // 去重的选中成员
      this.userList = [];
      arr.forEach((item) => {
        let obj = {
          userId: item.userId,
          userName: item.userName,
        };
        this.userList.push(obj);
      });
      this.selectNum = "已选 " + this.userList.length + " 位";
      this.getCusParams.userVoList = this.userList;
      if (this.userList.length != 0 && this.myType == 5) {
        this.getScreenCus();
      }
      this.dialogVisibleTree = false;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  // min-height: 504px;
}
/deep/.el-dialog__header {
  padding: 28px 32px 20px;
  .el-dialog__title {
    font-size: 16px;
    font-weight: bold;
  }
}
/deep/ .el-dialog__body {
  padding: 0px 24px 20px 32px;
}
/deep/ .el-dialog__footer {
  text-align: right;
  padding: 0 26px 20px;
}
.row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .required {
    color: #ff4b59;
    margin-right: 5px;
    transform: translate(0, 2px);
  }
  .label {
    margin-right: 15px;
    font-size: 14px;
    font-weight: bold;
  }
  .staff-select-wrap {
    display: flex;
    align-items: center;
  }
  .before-select {
    color: #999999;
  }
  .after-select {
    color: #333333;
    display: flex;
    align-items: center;
    .tip {
      color: #2684ff;
      margin-left: 14px;
      cursor: pointer;
      .btn-icon {
        transition: all 0.5s;
        margin-left: 4px;
        transform: rotate(0);
      }
      .btn-icon2 {
        transform: rotate(180deg);
      }
    }
  }
  /deep/.my-select {
    cursor: pointer;
    .el-input__inner {
      cursor: pointer;
    }
  }
}
.option-container {
  padding-left: 82px;
  display: flex;
  // transition: all 1s;
}
.select-wrap {
  margin-left: 80px;
  max-height: 200px;
  overflow: scroll;
  /deep/ .el-tag {
    margin: 4px 4px;
  }
}
.task-detail {
  padding: 0 11px;
  font-size: 12px;
  .detial-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .label {
      margin-right: 15px;
      font-size: 14px;
      font-weight: bold;
    }
    .icon-style {
      margin-left: 12px;
    }
  }
  /deep/.number-input {
    margin: 0 4px;
    .el-input__inner {
      padding: 0 4px 0 15px;
    }
  }
}
</style>
